import './RegionSelector2List.css';

import { Typography } from '@vtblife/uikit';
import React from 'react';
import classname from '@search/classname/src';
import { RegionSelector2Item } from './RegionSelector2Item';

const cn = classname.bind(null, 'RegionSelector2List');

export function RegionSelector2List({
    items,
    setSelectedId
}: {
    setSelectedId(id: RegionSelector2Item['id']): void;
    items: RegionSelector2Item[];
}) {
    const regionGroups = useLetterSplitter(items);

    return (
        <div className={cn()}>
            {regionGroups.map(({ key, regions }) => (
                <div className={cn('group')} key={key}>
                    <Typography
                        variant='h2'
                    >{key}</Typography>
                    {regions?.map(item => (
                        <button
                            key={item.id}
                            className={cn('link')}
                            onClick={e => {
                                e.preventDefault();
                                setSelectedId(item.id);
                            }}
                            data-test='region-item'
                        >{item.displayName}</button>
                    ))}
                </div>
            ))}
        </div>
    );
}

function useLetterSplitter<Item extends { displayName?: string | null }>(items: Item[]) {
    return React.useMemo(() => {
        const groups = new Map<string, Item[]>();

        for (const item of items) {
            const name = item.displayName;

            if (! name) continue;
            const key = name.substr(0, 1);

            let groupped = groups.get(key);

            if (! groupped) {
                groupped = [];
                groups.set(key, groupped);
            }
            groupped.push(item);
        }

        return Array.from(groups.keys()).sort().map(key => ({
            key,
            regions: groups.get(key)
        }));
    }, [ items ]);
}
